import { render, staticRenderFns } from "./StatusTransitionRecord.vue?vue&type=template&id=08b1b152&scoped=true&"
import script from "./StatusTransitionRecord.vue?vue&type=script&lang=js&"
export * from "./StatusTransitionRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b1b152",
  null
  
)

export default component.exports